export default __webpack_public_path__ + "static/media/Montserrat-BoldItalic.360c8432.ttf";